import { AxiosResponse } from 'axios';
import {
  EventFormData,
  ICreateEventResponse,
  IGetEventParams,
  IGetEventResponse,
  IUpdateEventParams,
  IUpdateEventResponse,
  ISendReminderResponse,
  SendReminderPayload,
} from '../../interface/eventModel';
import api from '../api';

const createEvent = async (
  payload: EventFormData,
): Promise<AxiosResponse<ICreateEventResponse>> => {
  const res: AxiosResponse<ICreateEventResponse> = await api.post('/event', payload);
  return res;
};

const getEvent = async (params: IGetEventParams): Promise<AxiosResponse<IGetEventResponse>> => {
  const { eventId } = params.pathParams;
  const res: AxiosResponse<IGetEventResponse> = await api.get(`/event/${eventId}`);
  return res;
};

const updateEvent = async (
  params: IUpdateEventParams,
): Promise<AxiosResponse<IUpdateEventResponse>> => {
  const { body, pathParams } = params;
  const { eventId } = pathParams;
  const res: AxiosResponse<IUpdateEventResponse> = await api.patch(`/event/${eventId}`, body);
  return res;
};

const sendReminder = async (
  eventId: string,
  payload: SendReminderPayload,
): Promise<AxiosResponse<ISendReminderResponse>> => {
  const res: AxiosResponse<ISendReminderResponse> = await api.post(
    `/event/${eventId}/reminder`,
    payload,
  );
  return res;
};

export const eventService = {
  createEvent,
  getEvent,
  updateEvent,
  sendReminder,
};
